import { cn } from "@/lib/utils";

/**
 * Logo Averdy Agency.
 *
 * Le fichier `/averdy-logo.webp` fait 800×186 avec le mot "AVERDY AGENCY"
 * en BLANC → invisible sur fond clair. On expose donc 2 variants :
 *
 * - `icon` : affiche uniquement le badge "A" (object-fit cover + crop à
 *   gauche). Utilisable sur n'importe quel fond. Dimensions carrées.
 * - `full` : logo complet avec le wordmark. À réserver aux fonds SOMBRES
 *   (footer, portail staff, panel login dark).
 */
export function BrandLogo({ variant = "icon", className = "", alt = "Averdy Agency" }) {
  if (variant === "full") {
    return (
      <img
        src="/averdy-logo.webp"
        alt={alt}
        className={cn("h-10 w-auto", className)}
      />
    );
  }
  // Variant "icon" : crop côté gauche du fichier (où se trouve le A).
  // ratio source 800×186 → l'icône A occupe ~0-186px → on force 1:1 avec
  // object-cover + object-left.
  return (
    <img
      src="/averdy-logo.webp"
      alt={alt}
      className={cn("h-9 w-9 object-cover shrink-0", className)}
      style={{ objectPosition: "0% 50%" }}
    />
  );
}

export default BrandLogo;
